import React from 'react';
import { queries } from '../../../graphql/graphql';
import ListContainer from '../../../components/containers/AdminList';

const ListDirectories: React.FC = () => {
  return (
    <ListContainer
      prefix="directory"
      query={queries.directories.DIRECTORIES}
      inline={true}
      editable={true}
      canCreate={true}
      adminView={true}
    />
  );
};

export default ListDirectories;
